export { default as GDMTableContainer } from './GDMTableContainer';

export type { GDMTableContainerComponent, GDMTableContainerProps } from './GDMTableContainer.type';
